'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./Spectrum.scss');

var Spectrum = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(Spectrum, _Component);

  function Spectrum() {
    (0, _classCallCheck3.default)(this, Spectrum);
    return (0, _possibleConstructorReturn3.default)(this, (Spectrum.__proto__ || (0, _getPrototypeOf2.default)(Spectrum)).apply(this, arguments));
  }

  (0, _createClass3.default)(Spectrum, [{
    key: 'render',
    value: function render() {
      var isActive = this.props.isActive;

      var spectrumClass = (0, _bind2.default)(styles.spectrum, (0, _defineProperty3.default)({}, styles.active, isActive));

      return _react2.default.createElement('i', { className: spectrumClass });
    }
  }]);
  return Spectrum;
}(_react.Component), _class.propTypes = {
  isActive: _propTypes2.default.bool
}, _temp);
exports.default = Spectrum;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Spectrum/Spectrum.js
// module id = 2107
// module chunks = 1